module.exports = __webpack_public_path__ + "img/equis.5c8e3df0.svg";